import AuthTitle from "./AuthTitle.styled";

export default AuthTitle;
